export class rolesEntryIdObj {
  	entryIds = [
      { id:'74jkKDv0XSqjZxVyRBBI7o'},
      { id:'3GialmlkTv0jskDMikA3iv'},
      { id:'yHNvwOizCqGMMM4eyHMz6'},
      { id:'2dkl6GS2pzi3YrTfH2PVYz'},
      { id:'5maBkXnYJIrZpuP3P2L0jN'},
      { id:'3yDStoG2H2RYFBTzVc5ZVd'}
  	];
}